// Copyright (c) Move Closer 2022.

import { IPatch } from '@/bootstrap/updater'

import { ClearCachesPatch } from '@/patches/clear-cache.patch'

/**
 * Here goes all patches that should be applied to application.
 *
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const patchesRegistry: IPatch[] = [
  new ClearCachesPatch()
]
